import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TDateFormat, TLocaleCode, TIconName, DateTimePicker } from '@treezor/design-system';

import { TCommonFilters } from '@/features/wallets/types/index';

import { CustomPopover, ICustomPopoverProps } from './CustomPopover';

interface IDateFieldFilterProps {
  onFilterChange: (filters: TCommonFilters) => void;
  label: string;
  minDate?: Date;
  maxDate?: Date;
  locale?: TLocaleCode;
  todayButtonLabel?: string;
  icon?: TIconName;
  dateFormat?: TDateFormat;
  className?: string;
  id: string;
}

export const DateRangeFilter = ({
  onFilterChange,
  todayButtonLabel,
  label,
  icon,
  className,
  id,
}: IDateFieldFilterProps) => {
  const { t } = useTranslation();
  const { watch, getValues, setValue } = useFormContext<TCommonFilters>();
  const dateFrom = watch('dateFrom');
  const dateTo = watch('dateTo');

  const handleDateRangeValues = (field: keyof TCommonFilters, value: Date) => {
    setValue(field, value);
    const operationsFilters = getValues();

    onFilterChange({
      ...operationsFilters,
    });
  };

  const dateFilter: ICustomPopoverProps = {
    id,
    label,
    icon,
    content: (
      <div className="flex flex-col gap-3 p-5">
        <DateTimePicker
          selectedDate={dateFrom}
          label={t('pages.currentProfiles.wallets.operations.download.dateFrom')}
          todayButtonLabel={todayButtonLabel}
          clearButtonLabel={t('components.atoms.datefield.clear')}
          onChangeDate={(date) => handleDateRangeValues('dateFrom', date)}
          maxDate={dateTo ? dateTo : new Date()}
          testId="date-from"
        />

        <DateTimePicker
          selectedDate={dateTo}
          label={t('pages.currentProfiles.wallets.operations.download.dateTo')}
          todayButtonLabel={todayButtonLabel}
          clearButtonLabel={t('components.atoms.datefield.clear')}
          onChangeDate={(date) => handleDateRangeValues('dateTo', date)}
          minDate={dateFrom ? dateFrom : undefined}
          maxDate={new Date()}
          testId="date-to"
        />
      </div>
    ),
    indication: [dateFrom, dateTo].filter((date) => date).length,
  };

  return (
    <CustomPopover
      label={dateFilter.label}
      icon={dateFilter.icon}
      content={dateFilter.content}
      indication={dateFilter.indication}
      itemClassName={className}
      id={dateFilter.id}
    />
  );
};
